module.exports = __webpack_public_path__ + "img/solar-user-linear.2f37fc0a.svg";